import React, { useCallback } from "react";
import { DeleteIcon } from "@chakra-ui/icons";
import { Button } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { RouteIdParam } from "modules/shared/schemas/paramsSchema";
import { useTranslation } from "react-i18next";
import useFeedbackStore from "modules/feedback/hooks/useFeedbackStore";
import {
  actionsSchema,
  feedbackSchema,
} from "core/components/ActionFeedback/schemas/actionSchemas";
import { useDeleteGlobalMessage } from "../hooks/useDeleteGlobalMessage";
import useGlobalMessage from "../hooks/useGlobalMessage";

const DeleteGlobalMessageAction = () => {
  const { id } = useParams<RouteIdParam>();
  const deleteGlobal = useDeleteGlobalMessage();
  const { setFeedback } = useFeedbackStore();
  const { t } = useTranslation();
  const { data } = useGlobalMessage();
  const handleDelete = useCallback(() => {
    setFeedback(
      feedbackSchema.enum.warning,
      actionsSchema.enum.deleteGlobal,
      () => (id ? deleteGlobal.mutate(id) : {})
    );
  }, [id, deleteGlobal]);
  const isFinalizedGlobal = data && data.status === "PRODUCTION";

  return (
    <Button
      onClick={handleDelete}
      leftIcon={<DeleteIcon />}
      variant="primary-solid"
      isDisabled={!isFinalizedGlobal}
    >
      {t("global_message.delete")}
    </Button>
  );
};

export default DeleteGlobalMessageAction;
